import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getDirectTokenPermissions } from '@uxdf/direct-shared-lib';
import { State } from '../redux/reducers';

@Injectable()
export class TokenPermissionGuard implements CanActivate {
  constructor(private readonly store: Store<State>, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    let requiredPermission: string;
    let redirectPath: string;
    try {
      const guardData = route.data['permissionGard'];
      [requiredPermission, redirectPath] = [guardData['requiredPermission'], guardData['redirect']];
    } catch (_) {
      console.error('Token guard misconfiguration');
      return of(false);
    }
    if (redirectPath === state.url) {
      return of(true);
    }

    return this.store.pipe(
      select(getDirectTokenPermissions),
      take(1),
      map(permissions => {
        if (permissions[requiredPermission]) {
          return true;
        }
        console.warn('[TOKEN GUARD]');
        return this.router.createUrlTree([redirectPath]);
      })
    );
  }
}
